import classNames from 'classnames'
import { useMemo } from 'react'
import { Spacing, GemColors } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import * as styles from './styles'

export type DotLoaderProps = {
  className?: string
  dotSize?: number
  height?: number
}

export const DotLoader: React.FC<DotLoaderProps> = ({
  className,
  height,
  dotSize = Spacing.XS * 2,
}) => {
  const theme = useTheme()
  const dotStyles = useMemo(() => {
    const baseColors = [GemColors.N300, GemColors.N250, GemColors.N150]
    const [color1, color2, color3] =
      theme == 'light' ? baseColors : baseColors.reverse()

    return [
      styles.dot({ colors: [color1, color2, color3], dotSize }),
      styles.dot({ colors: [color2, color3, color1], dotSize }),
      styles.dot({ colors: [color3, color1, color2], dotSize }),
    ]
  }, [dotSize, theme])

  return (
    <div
      aria-label="Loading…"
      aria-live="polite"
      className={classNames('lapidary-dot-loader', className)}
      css={styles.layout(height)}
      role="status"
    >
      {dotStyles.map((dotStyle, index) => (
        <div key={index} aria-hidden css={dotStyle} />
      ))}
    </div>
  )
}
DotLoader.displayName = 'Lapidary: DotLoader'
